module.exports = __webpack_public_path__ + "img/service-default-w390.41d1cf8.jpg";